const theme = {
    colors: {
        black: `#000000`,
        white: '#FFFFFF',

        textAccessibleWG01: '#615B54', //gray900 neutral07 neutral05 neutral06 neutral08
        textAccessibleWG02: '#241F1A',
        textAccessibleA02: '#562E1C4D',
        textAccessibleSG01: '#007C4A',

        solidA01: '#E15E12', // replacing primaryBlue08, primaryBlue09, blue600
        solidA02: '#D35100', //, replacing primaryBlue07, primaryBlue05, primaryBlue

        solidWG01: '#8B847D',
        solidWG02: '#807973', //gray400 gray500

        solidSY01: '#DCAA06',

        backgroundWG01: '#F9F7F6', //replaces gray100 primaryBlue01
        backgroundA01: '#F9F6F4',
        backgroundWG02: '#F5F3F1', //replaces backgroundWhite neutral02
        backgroundSG02: '#EEF5F1',

        interactiveA01: '#FDE5DB', //replaces primaryBlue03
        interactiveWG01: '#EDE9E6',
        interactiveWG03: '#DFD9D4', //replaces neutral03

        bordersWG01: '#D8D1C9', //replaces gray200 gray300 neutral04
        bordersWG03: '#B9B2AB',

        bordersSG01: '#A2D7BB',

        green10: '#069866',
        blue: '#387BB3',

        // NX Text Colors (neutral WG tier)
        neutral09: '#241F1A', // Text Primary Color / Text Accessible WG01 preMigration #2E3842, // Main text, Tooltips background

        // NX Gray (Text & Borders)
        gray600: '#241F1A', // Text Accessible WG01 preMigration #475467',
        gray700: '#241F1A', // Text Primary Color preMigration '#344054',
        gray800: '#241F1A', // Text Accessible WG01 preMigration  #1D2939',
        gray950: '#241F1A', // Text Accessible WG01 preMigration #4B4B4D,

        // LEGACY - Remove after full migration
        orange11: '#885904',
        orange10: '#6C4600',
        orange09: '#996300',
        orange08: '#FF8001', // Text- call to action on notification preview
        orange06: '#FF8001', //Logo, Graphs
        orange05: '#FF981A', // graphs
        orange04: '#FEAD4A', // graphs
        orange03: '#FFC680', // graphs
        orange02: '#FFF2D9', // graphs
        orange01: '#fff5d966',

        error: '#F04438',
        success: '#12A670',
        warning: '#F7BD00',

        warningDisabled: '#FFFBE7',

        neutral01: '#FAFBFC', //Grey line in tables background./ background color in a lot of things

        // Old Primary colors
        primary25: '#fafaff', // background color
        primary50: '#FDE5DB', //'#f4f3ff', // background and border color
        primary100: '#fafaff', // background and icon secondary color
        primary300: '#fafaff', // border and background
        // Secondary
        secondary25: '#FEF4F1',
        secondary50: '#FEEFEB',
        secondary100: '#FEE3DC',
        secondary500: '#FF7D45',
        secondaryGray: '#6A7784',
        // Success
        success25: '#E3F9F1',
        success50: '#C6F5E4',
        success100: '#A9EFD5',
        success200: '#91E3C5',
        success300: '#63DDB0',
        success400: '#48D4A0',
        success500: '#2ECE93',
        success600: '#1FA382',
        success700: '#14795F',
        success800: '#05603A',
        success900: '#054F31',
        // Error
        error25: '#FFF5F5',
        error50: '#FEECEA',
        error100: '#FEE4E2',
        error400: '#F97066',
        error500: '#F04438',
        error600: '#D92D20',
        error700: '#B42318',
        // Warning
        warning25: '#FFFDF7',
        warning50: '#FFF5D9',
        warning300: 'FEC84B',
        warning500: '#F79009',
        warning600: '#DC6803',
        warning700: '#B54708',
        // gray
        gray25: '#F9F9FB', //background color
        gray50: '#F5F6F8', //background color seems to often be opposite of gray200
        gray75: '#F9F9F9',
        gray150: '#E1E9F2',
        gray250: '#F8F9FA',
        gray450: '#6A7784',

        //blueLight
        blueLight25: '#F5FBFF',
        blueLight500: '#0BA5EC',

        //blue
        blue400: '#3982BF',
        blue500: '#B5B5D2',
        blue700: '#C44700', //Text Accessible A01 preMigration//'#15569B',
        blue900: '#1E282D',
        blue1000: '#369BFF',

        // blueGray
        blueGray50: '#EAEAEA',
        blueneutral09: '#4E5BA6',

        // indigo
        indigo50: '#EEF4FF',
        indigo100: '#E0EAFF',
        indigo500: '#6172F3',
        indigo700: '#3538CD',
        indigo800: '#7155C6',

        //orange
        orange100: '#FEAD4A',
        orange200: '#FF981A',
        orange300: '#FF8001',
        orange400: '#FF8001',
        orange500: '#FF6C6C',
        orange600: '#FF5F48',
        orange700: '#F97066',

        //green
        green1: '#219653',
        green2: '#27AE60',
        green500: '#008000',
        green600: '#00CF9D',
        green700: '#1AA673',
        green800: '#0C7D53',
        green900: '#25BC96',

        //yellow
        yellow50: '#FFFDE7',

        //pink
        redPink: '#E57065',

        //red
        warningRed: '#EB5757',

        //lime
        lime500: '#41AB5D',
        lime600: '#1C735B',
        limeGreen: '#A8C009',

        //fuchsia
        fuchsia600: '#BA24D5',

        //turquoise
        turquoise500: '#00C0C7',
        turquoise100: '#E4FDFE',

        //teal
        teal500: '#14A99F',

        // tag
        tagBGColor: '#E7EDF3',
        tagBorderColor: '#DFE0E2',

        // ComposerNX colors
        composerNXPrimary: '#E15E12', // Primary orange color for buttons and icons
        composerNXText: '#615B54', // Text color for descriptions and subtitles
        composerNXTextDark: '#241F1A', // Dark text color for feature titles
        composerNXSectionHeader: '#8B847D', // Muted color for section headers
    },
    customComponentColors: {
        brightLimeGreen: '#6EE016',
        amber: '#CE8A1E',
        redOrange: '#F97253',
        gold: '#F6D606',
        aquaGreen: '#05F2BF',
        royalBlue: '#1C73FF',
        violet: '#A843DF',
        turquoise: '#43DFDC',
        aquamarine: '#43DFA6',
        shockingOrange: '#DF6843',
        hotPink: '#FF62A6',
        bitterLemon: '#D4E216',
        beanRed: '#F55751',
    },
    variantTypeColors: {
        ValueProposition: '#E4DCFF',
        Greeting: '#D2E9FC',
        Offering: '#F5E4EE',
        CallToAction: '#EDF2C7',
        Incentive: '#FFE8CB',
        Other: '#D7F7F5',
        Tone: '#FFEEF4',
        Image: '#2848B7',
    },
    variantTypeHoverBgColors: {
        ValueProposition: '#B8AAE3',
        Greeting: '#8FBBE1',
        Offering: '#D4A5BE',
        CallToAction: '#D3DF84',
        Incentive: '#FFCB8D',
        Other: '#8BD7D2',
        Tone: '#FFBAD2',
    },
    liveMessagesColors: {
        surfaces: '#EBBDBC',
        email: '#FFCB8D',
        contentCard: '#FCEC83',
        sms: '#9BADEF',
        mobilePush: '#A9EFD5',
        webPush: '#BBF58E',
        whatsapp: '#D3DF84',
    },
    mapCellColors: {
        empty: '#FEF5E0',
        opportunityCorner: '#FFD74F',
        default: '#F9F7F6',
        defaultHover: '#EDE9E6',
        gapCorner: '#8B847D',
        gapHover: '#DFD9D4',
        opportunityHover: '#FEF5E0',
    },
    dataVizColors: {
        color1: '#00C0C7',
        color2: '#5143D3',
        color3: '#E8871A',
        color4: '#DA338F',
        color5: '#9089FA',
        color6: '#47E26F',
        color7: '#2680EB',
        color8: '#6F38B1',
        color9: '#DFBF03',
        color10: '#CB6F0F',
    },
    toastTitleColor: {
        success: '#193B2B (Text Accessible SG02)', // preMigration  #2A6F56'
        error: '#621F19 (Text Accessible SR02)', // preMigration  '#7A1F1F',
        warning: '#483B1A (Text Accessible SY02)', // preMigration  '#996300',
        info: '#241F1A (Text Accessible WG02)', //preMigration '#0b0b0c'
    },
    toastIconColor: {
        success: '#193B2B (Text Accessible SG02)', //preMigration  '#51BD95',
        error: '#621F19 (Text Accessible SR02)', //preMigration  '#D04444',
        warning: '#483B1A (Text Accessible SY02)', //preMigration  '#FFB020',
        info: '#807973 (Solid WG02)', //preMigration '#3366FF',
    },
    toastInlineBgColor: {
        success: '#EEF5F1', // preMigration'#F5FBF8',
        error: '#F9F2F1', // preMigration'#FDF4F4',
        warning: '#FEF5E0', // preMigration'#FFFAF2',
        info: '#F9F7F6', // (Background WG01)',// preMigration'#F4F6FF',
    },
    // @deprecated: use spacing4 from now
    spacing: (...factors: number[]) =>
        factors.reduce((result, factor) => result + `${factor * 8}px `, ''),
    spacing4: (...factors: number[]) =>
        factors.reduce((result, factor) => result + `${factor * 4}px `, ''),
    spacing4WithOffset: (factor: number, offset: number) =>
        `${factor * 4 + offset}px`,
    borderRadius: {
        default: '4px',
        small: '6px',
        large: '20px',
        intermediate: '12px',
        medium: '8px',
        message: '16px',
        tableCell: '1px',
    },
    size: {
        icon: {
            large: '26px',
            default: '24px',
            normal: '20px',
            small: '18px',
        },
        pageMaxWidth: {
            default: '1540px',
        },
        inputHeight: {
            default: '44px',
            defaultV2: '40px',
        },
        filterHeight: {
            default: '36px',
        },
        font: {
            default: '16px',
            text: '18px',
            title: '20px',
            heading: '24px',
            textMedium: '14px',
            textSmall: '12px',
            textExtraSmall: '10px',
            textLarge: '28px',
        },
        lineHeight: {
            mediumSmall: '14px',
            textSmall: '18px',
            small: '20px',
            default: '24px',
            tall: '28px',
            extraTall: '30px',
            extraSmall: '12px',
        },
    },
    composerNX: {
        spacing: {
            modal: {
                container: '24px',
                gap: '16px',
                width: '800px',
            },
        },
    },
    weights: {
        light: 400,
        medium: 500,
        heavy: 600,
        extraHeavy: 700,
    },
    boxShadow: {
        default:
            '0px 11.3676px 13.6411px -2.27351px rgba(16, 24, 40, 0.08), 0px 4.54703px 4.54703px -2.27351px rgba(16, 24, 40, 0.03)',
    },
    status: {
        active: {
            backgroundColor: '#EBFFFF',
            color: '#05ADA9',
        },
        revoked: { backgroundColor: '#F5F3F1', color: '#3A3A3A' },
        incomplete: { backgroundColor: '#FFF4EF', color: '#FF5F48' },
    },
};

export default theme;
